/** Group only already-authorised appointment rows in the Institution timezone. */
export function institutionAppointmentDay(value, timezone) {
  if (!value || !timezone) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: timezone, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(date);
  const part = (type) => Number(parts.find((entry) => entry.type === type)?.value);
  return { year: part("year"), month: part("month"), day: part("day") };
}

export function institutionAppointmentCalendarCounts(rows, timezone, year, month) {
  const counts = new Map();
  if (!Array.isArray(rows) || !timezone) return counts;
  for (const row of rows) {
    const local = institutionAppointmentDay(row?.appointment_date, timezone);
    if (local?.year !== year || local?.month !== month) continue;
    counts.set(local.day, (counts.get(local.day) || 0) + 1);
  }
  return counts;
}
